import { useAuthContext } from '@lp/core/auth';
import { Quote } from '@/api/apis/case';
import { useGetQuoteByIdQuery } from '@/queries/quotes';
import { RouteQuote } from '@/api/apis/quote';
import { CaseDetailsPermissions } from '@/permissions';

type UseGetQuoteDetailsProps = {
  quote?: Quote;
};

export const useGetQuoteDetails = ({ quote }: UseGetQuoteDetailsProps): RouteQuote | null => {
  const { checkPermission } = useAuthContext();
  const hasPermission = checkPermission(CaseDetailsPermissions.CaseQuoteRead);
  const { data } = useGetQuoteByIdQuery(hasPermission ? quote?.quoteId : undefined);

  return data || null;
};
